










































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { getCookie } from "../JS/cookie"; //使用getCookie方法
import tinymce from "@/components/editor/tinymce2.vue"; //引入tinymce
import axios from "axios";
import userInfo from '@/store/modules/userInfo';
@Component({
  components: { tinymce }
})
export default class LeftMenu extends Vue {
  @Prop() private momentDataArr!: any; // 存储数据的二维对象
  @Prop() private activeRow!: number; // 父组件传值当前行
  @Provide() activeTencent: any = ""; // 当前公众号
  @Provide() replyObj: any = ""; // 添加修改对象
  @Provide() videoAction: any = "";
  @Provide() replyType: any = [
    { typeID: "1", label: "文字", value: "wx-text", iconName: "text" },
    { typeID: "2", label: "图片", value: "wx-image", iconName: "image" },
    {
      typeID: "3",
      label: "图文消息",
      value: "wx-image-text",
      iconName: "tuwen"
    },
    { typeID: "4", label: "语音", value: "wx-voice", iconName: "voice" },
    { typeID: "5", label: "视频", value: "wx-video", iconName: "video" },
    { typeID: "6", label: "模板消息", value: "wx-template", iconName: "moban" },
    {
      typeID: "7",
      label: "微信小程序",
      value: "miniprogram",
      iconName: "miniprogram"
    }
  ];
  @Provide() activeCate: any = "";
  @Provide() SearchKeywords: string = "";
  @Provide() replyDialogVisible: boolean = false;

  // 显示弹窗
  showFodderDialog(activeCate: any) {
    let _this = this;
    _this.replyDialogVisible = true;
    _this.activeCate = activeCate;
    if (_this.momentDataArr[_this.activeRow].endRow == 5) {
      if (_this.tempList == "") {
        _this.loadMessageList();
      }
    }else {
      _this.getFodderList(activeCate.ID);
    }
  }
  // 搜索素材
  searchFodder(activeCate: any) {
    let _this = this;
    if (Number(_this.momentDataArr[_this.activeRow].endRow) == 5) {
      _this.loadMessageList();
    } else {
      _this.getAllFodderList();
    }
    this.activeCate = "全部";
  }
  // 获取素材分组
  async getCateList() {
    let _this = this;
    let replyType = Number(_this.momentDataArr[_this.activeRow].endRow);
    if (replyType == 6) {
      replyType = 1;
    }
    let params: any = {
      Input: [
        {
          Name: "data",
          Value: { AppReplyType: replyType + 1, ActionName: 4,ApplicationID:_this.activeTencent.Aid }
        }
      ]
    };
    let res: any = await httpApi.GetFodderCate(params);
    if (res.ErrorCode == 0) {
      switch (replyType) {
        case 1:
        case 6:
          _this.imgCateList = res.output[0].value;
          _this.activeImgCate = _this.imgCateList[0];
          _this.activeCate = _this.activeImgCate;
          break;
        case 2:
          _this.imgTxtCateList = res.output[0].value;
          _this.activeImgTxtCate = _this.imgTxtCateList[0];
          _this.activeCate = _this.activeImgTxtCate;
          break;
        case 3:
          _this.voiceCateList = res.output[0].value;
          _this.activeVoiceCate = _this.voiceCateList[0];
          _this.activeCate = _this.activeVoiceCate;
          break;
        case 4:
          _this.videoCateList = res.output[0].value;
          _this.activeVideoCate = _this.videoCateList[0];
          _this.activeCate = _this.activeVideoCate;
          break;
      }
    } else {
      this.$message("分组获取失败！");
      console.log(res.ErrorMessage);
    }
  }

  // 获取分组素材列表
  async getFodderList(groupId: any) {
    let _this = this;
    let replyType = Number(_this.momentDataArr[_this.activeRow].endRow);
    // { "Input":[{"Name":"data","Value":{"GroupID":"1",  "ActionName": 4}}]}
    let params: any = {
      Input: [
        {
          Name: "data",
          Value: { GroupID: groupId, MediaName: "", ActionName: 4 }
        }
      ]
    };
    let res: any = await httpApi.GetFodderList(params);
    if (res.ErrorCode == 0) {
      switch (replyType) {
        case 1:
        case 6:
          _this.imgList = res.output[0].value;
          break;
        case 2:
          _this.imgTxtList = res.output[0].value;
          break;
        case 3:
          _this.voiceList = res.output[0].value;
          break;
        case 4:
          _this.videoList = res.output[0].value;
          break;
      }
    } else {
      this.$message("素材列表获取失败！");
      console.log(res.ErrorMessage);
    }
  }

  // 获取所有素材
  async getAllFodderList() {
    let _this = this;
    // { "Input":[{"Name":"data","Value":{"AppReplyType":"3","ActionName": 4}}]}
    let replyType = Number(_this.momentDataArr[_this.activeRow].endRow);
    if (replyType == 6) {
      replyType = 1;
    }
    let params: any = {
      Input: [
        {
          Name: "data",
          Value: {
            AppReplyType: replyType + 1,
            MediaName: _this.SearchKeywords,
            ApplicationID:_this.activeTencent.Aid,
            ActionName: 4
          }
        }
      ]
    };
    let res: any = await httpApi.GetAllFodderList(params);
    if (res.ErrorCode == 0) {
      switch (replyType) {
        case 1:
        case 6:
          _this.imgList = res.output[0].value;
          break;
        case 2:
          _this.imgTxtList = res.output[0].value;
          break;
        case 3:
          _this.voiceList = res.output[0].value;
          break;
        case 4:
          _this.videoList = res.output[0].value;
          break;
      }
    } else {
      this.$message("全部素材列表获取失败！");
      console.log(res.ErrorMessage);
    }
  }

  //切换回复类型
  changeReplyType(replyindex: number) {
    let _this = this;
    _this.momentDataArr[_this.activeRow].endRow = replyindex;
    switch (replyindex) {
      case 1:
      case 6:
        if (_this.imgCateList == "") {
          _this.getCateList();
        }
        break;
      case 2:
        if (_this.imgTxtCateList == "") {
          _this.getCateList();
        }
        break;
      case 3:
        if (_this.voiceCateList == "") {
          _this.getCateList();
        }
        break;
      case 4:
        if (_this.videoCateList == "") {
          _this.getCateList();
        }
        break;
      case 5:
        if (_this.tempCateList == "") {
          _this.loadCategoryList();
        }
        break;
    }
  }

  @Provide() textReplyData: any = "";
  @Provide() disabled: boolean = false;
  getEditValue(value: any) {
    let _this = this;
    _this.momentDataArr[_this.activeRow].rowArr[0].data = value;
  }
  // Emoji表情
  @Provide() activeEmoji: string = "常用";
  @Provide() emojiList: any = [];
  //加载表情
  async GetCustomEmoji() {
    let params: any = {
      Input: [
        {
          Name: "AppEmotionDTO",
          Value: {
            TenantID: this.activeTencent.TenantID
          } //消息模板类型
        }
      ]
    };
    var res: any = await httpApi.GetCustomEmoji(params);
    if (res.ErrorCode == 0) {
      this.emojiList = res.output[0].value;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  // Tab切换事件
  handleClick(tab: any, event: any) {
    if (tab.name == "second" && this.emojiList.length == 0) {
      this.GetCustomEmoji();
    }
  }
  selectEmoji(emoji: any) {
    let _this = this;
    _this.momentDataArr[_this.activeRow].rowArr[0].data += emoji[1];
  }
  // 文字链接
  @Provide() linkData: any = {
    linkText: "",
    link: ""
  };
  @Provide() linkDataRules: any = {
    linkText: [
      { required: true, message: '请输入链接文字', trigger: 'blur' },
      { min: 1, max: 20, message: "长度在 3 到 5 个字符", trigger: "blur" }
    ],
    link: [
      { required: true, message: '请输入网址', trigger: 'blur' },
      {
        pattern: /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/,
        // pattern: /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[a-zA-Z]\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/,
        message: "链接地址不正确",
        trigger: "blur"
      }
    ]
  };
  // 添加链接
  // <img src='https://img.crd.cn/upload/article/2020090811545148044860.png' width='16' style='vertical-align: middle; width:16px;' />
  pushLinkToMenuData(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        let _this = this;
        let linkStr =
          "<a style='color:#3699FF; text-decoration:none;' href='" +
          _this.linkData.link +
          "' title='" +
          _this.linkData.linkText +
          "'>" +
          _this.linkData.linkText +
          "</a>";
        _this.momentDataArr[_this.activeRow].rowArr[0].data += linkStr;
        _this.linkData.linkText = "";
        _this.linkData.link = "";
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  resetLinkForm(formName: any) {
    (this.$refs[formName] as any).resetFields();
  }

  // 小程序链接
  @Provide() miniprogram: any = {
    linkText: "",
    appid: "",
    pagePath: "",
    pagepathTwo: ""
  };
  @Provide() miniprogramRules: any = {
    linkText: [
      { required: true, message: "必填", trigger: "blur" },
      { min: 1, max: 20, message: "标题不超过20个汉字", trigger: "blur" }
    ],
    appid: [
      { required: true, message: "必填", trigger: "blur" },
      {
        pattern: /^wx[a-z0-9]{16}$/,
        message: "请输入正确的小程序appid",
        trigger: "blur"
      }
    ],
    pagePath: [
      { required: true, message: "必填", trigger: "blur" },
      {
        pattern: /^\/\w+/,
        message: "请输入正确的小程序地址",
        trigger: "blur"
      }
    ]
  };
  pushMiniToMenuData(miniprogramForm: any) {
    (this.$refs[miniprogramForm] as any).validate((valid: any) => {
      if (valid) {
        let _this = this;
        let miniprogramStr =
          "<a style='color:#409FFF;' href='"+ _this.miniprogram.pagepathTwo +"' data-miniprogram-appid='" +
          _this.miniprogram.appid +
          "' data-miniprogram-path='" +
          _this.miniprogram.pagePath +
          "'>" +
          _this.miniprogram.linkText +
          "</a>";
        _this.momentDataArr[_this.activeRow].rowArr[0].data += miniprogramStr;

        // 清空表单的内容
        _this.miniprogram.linkText = "";
        _this.miniprogram.appid = "";
        _this.miniprogram.pagePath = "";
        _this.miniprogram.pagepathTwo = "";
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  // 粉丝昵称
  pushFansName() {
    let _this = this;
    _this.momentDataArr[_this.activeRow].rowArr[0].data += '[粉丝昵称]';
  }

  // 图片回复
  @Provide() imgCateList: any = ""; // 图片素材分组列表
  @Provide() imgList: any = []; // 图片列表
  @Provide() activeImgCate: any = ""; // 当前图片分类
  @Provide() activeImgValue: any = []; // 已选图片对象
  chooseImgCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.getAllFodderList();
      _this.activeCate = "全部";
    } else {
      _this.getFodderList(clickCate.ID);
      _this.activeImgCate = _this.activeCate = clickCate;
    }
  }
  chooseImg(imgObj: any) {
    let _this = this;
    _this.activeImgValue = imgObj;
  }
  pushChooseImg() {
    let _this = this;
    if (_this.activeImgValue.length == 0) {
      this.$message.error("请选择图片素材！");
      return;
    }
    _this.momentDataArr[this.activeRow].rowArr[1].data = _this.activeImgValue;
    _this.replyDialogVisible = false;
  }

  // 图文回复
  @Provide() imgTxtCateList: any = "";
  @Provide() imgTxtList: any = [];
  @Provide() activeImgTxtCate: any = "";
  @Provide() activeImgTxtValue: any = [];
  chooseImgTxtCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.getAllFodderList();
      _this.activeCate = "全部";
    } else {
      _this.getFodderList(clickCate.ID);
      _this.activeCate = _this.activeImgTxtCate = clickCate;
    }
  }
  chooseImgTxt(imgTxtObj: any) {
    let _this = this;
    _this.activeImgTxtValue = imgTxtObj;
  }
  pushChooseImgTxt() {
    let _this = this;
    if (_this.activeImgTxtValue.length == 0) {
      this.$message.error("请选择图文素材！");
      return;
    }
    _this.momentDataArr[this.activeRow].rowArr[2].data =
      _this.activeImgTxtValue;
    _this.replyDialogVisible = false;
  }
  /**
   * 同步微信图文
   */
  async syncWeChatImgText(loadType:string){
    let _this = this;
    let params = { 
      Input:[
        {
          Name: "Aid",
          Value: _this.activeTencent.Aid
        },
        {
          Name: "Type",
          Value: loadType
        },
        {
          Name: "GroupID",
          Value: _this.activeCate.ID
        }
      ]
    };
    var res: any = await httpApi.loadImgTextFormWechat(params);
    if (res.ErrorCode == 0) {
      switch(_this.momentDataArr[_this.activeRow].endRow){
        case 2:
          _this.chooseImgTxtCate(_this.activeCate);//_this.imgTxtList = res.output[0].value;
          break;
        case 4:
          _this.chooseVideoCate(_this.activeCate);// = res.output[0].value;
          break;
      }
    } else {
      this.$message.info(res.ErrorMessage);
    }
  }

  // 音频回复
  @Provide() playVoiceValue: any = ""; //当前播放的音频
  @Provide() voiceCateList: any = "";
  @Provide() voiceList: any = "";
  @Provide() activeVoiceCate: any = "";
  @Provide() activeVoiceValue: any = [];
  @Provide() uploadLoading = false;
  chooseVoiceCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.getAllFodderList();
      _this.activeCate = "全部";
    } else {
      _this.getFodderList(clickCate.ID);
      _this.activeCate = _this.activeVoiceCate = clickCate;
    }
  }
  chooseVoice(voiceObj: any) {
    let _this = this;
    _this.activeVoiceValue = voiceObj;
  }
  pushChooseVoice() {
    let _this = this;
    if (_this.activeVoiceValue.length == 0) {
      this.$message("未选择音频！");
      return;
    }
    _this.momentDataArr[_this.activeRow].rowArr[3].data =
      _this.activeVoiceValue;
    _this.replyDialogVisible = false;
  }
  // 音频播放
  clearVoiceTabData() {
    let _this = this;
    _this.momentDataArr[_this.activeRow].rowArr[3].data = "";
    this.playVoiceValue = "";
    (this.$refs as any).playVoiceEl.pause();
  }
  voiceControl(listenVoice: any) {
    let _this = this;
    let isPlay = (this.$refs as any).playVoiceEl.paused;
    if (_this.playVoiceValue != "") {
      if (_this.playVoiceValue.ID == listenVoice.ID) {
        if (isPlay) {
          (this.$refs as any).playVoiceEl.play();
        } else {
          _this.playVoiceValue = "";
          (this.$refs as any).playVoiceEl.pause();
        }
      } else {
        _this.playVoiceValue = listenVoice;
        (this.$refs as any).playVoiceEl.play();
      }
    } else {
      _this.playVoiceValue = listenVoice;
      (this.$refs as any).playVoiceEl.play();
    }
  }

  // 发送消息-视频
  @Provide() videoCateList: any = "";
  @Provide() videoList: any = "";
  @Provide() activeVideoCate: string = "";
  @Provide() activeVideoValue: any = [];
  @Provide() playVideoValue: any = "";
  @Provide() videoPlayDialogVisible: boolean = false;
  chooseVideoCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.getAllFodderList();
      _this.activeCate = "全部";
    } else {
      _this.getFodderList(clickCate.ID);
      _this.activeCate = _this.activeVideoCate = clickCate;
    }
  }
  chooseVideo(clickVideo: any) {
    let _this = this;
    _this.activeVideoValue = clickVideo;
  }
  pushChooseVideo() {
    let _this = this;
    if (_this.activeVideoValue.length == 0) {
      this.$message("未选择视频！");
      return;
    }
    _this.momentDataArr[_this.activeRow].rowArr[4].data =
      _this.activeVideoValue;
    _this.replyDialogVisible = false;
  }
  // 视频播放
  clearvideoTabData() {
    let _this = this;
    _this.activeVideoValue = "";
    _this.momentDataArr[_this.activeRow].rowArr[4].data =
      _this.activeVideoValue;
  }
  videoControl(playVideo: any) {
    if (this.videoPlayDialogVisible) {
      this.videoPlayDialogVisible = false;
      this.playVideoValue = "";
    } else {
      this.playVoiceValue = playVideo;
      this.videoPlayDialogVisible = true;
    }
  }

  // 回复模板消息模板
  @Provide() tempCateList: any = "";
  @Provide() tempList: any = "";
  @Provide() tempGroupList: any = "";
  @Provide() activeTempCate: any = "";
  @Provide() activeTempValue: any = [];
  @Provide() colNum: number = 0;
  filterTempGroupList() {
    let _this = this;
    let grouList: any = [];
    _this.tempList.forEach((temp: any) => {
      if (temp.template_category == _this.activeTempCate.TypeName) {
        grouList.push(temp);
      }
    });
    _this.tempGroupList = grouList;
    _this.colNum = Math.ceil(_this.tempGroupList.length / 3);
  }
  chooseTempCate(clickCate: any) {
    let _this = this;
    if (clickCate == "all") {
      _this.tempGroupList = _this.tempList;
      _this.activeCate = "全部";
      _this.colNum = Math.ceil(_this.tempGroupList.length / 3);
    } else {
      _this.activeCate = _this.activeTempCate = clickCate;
      _this.filterTempGroupList();
    }
  }
  chooseTemp(clickTemp: any) {
    let _this = this;
    _this.activeTempValue = clickTemp;
  }
  pushChooseTemplate() {
    let _this = this;
    if (_this.activeTempValue.length == 0) {
      this.$message("未选择模板消息！");
      return;
    }
    _this.momentDataArr[_this.activeRow].rowArr[5].data = _this.activeTempValue;
    _this.replyDialogVisible = false;
  }
  toCreateTemp() {
    let routeData = this.$router.resolve({
      name: "/tenants/tenantsView/wx-message_ModelTable",
      params: { parentcode: "M159" }
    });
    localStorage.setItem("menuKey", "M159");
    localStorage.setItem("slideKey", "M198");
    localStorage.setItem("target", "_blank");
    window.open(routeData.href, "_blank");
  }
  /** 加载模板数据 */
  async loadMessageList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.activeTencent.Aid
        },
        {
          Name: "status",
          Value: 1
        }
      ]
    };
    var res: any = await httpApi.GetAppMessageTemplateList(params);
    if (res.ErrorCode == 0) {
      _this.tempList = res.output[0].value;
      _this.filterTempGroupList();
      var result = res.output[0].value;
      if (this.SearchKeywords) {
        _this.tempGroupList = result.filter((item: any, index: any) =>
          item.template_title.includes(this.SearchKeywords)
        );
      }
    } else {
      this.$message.error(res.ErrorMessage);
    }
  }
  /** 加载分类列表 */
  async loadCategoryList() {
    let _this = this;
    let params: any = {
      Input: [
        {
          Name: "Model",
          Value: { ApplicationId: this.activeTencent.Aid, Status: 1 }
        }
      ]
    };
    var res: any = await httpApi.GetAppMessageTemplateType(params);
    if (res.ErrorCode == 0) {
      _this.tempCateList = res.output[0].value;
      _this.activeTempCate = this.tempCateList[0];
      _this.activeCate = this.activeTempCate;
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }

  /** 回复小程序 */
  @Provide() toSmallProgramData: any = {
    title: "",
    appid: "",
    pagePath: "",
    pagePathTwo: "",
    coverImg: ""
  };
  @Provide() miniDialogVisible: boolean = false;
  @Provide() smallProgramRules: any = {
    title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
    appid: [
      { required: true, message: "请输入正确的小程序appid", trigger: "blur" },
      {
        pattern: /^wx[a-z0-9]{16}$/,
        message: "请输入正确的小程序appid",
        trigger: "blur"
      }
    ],
    pagePath: [
      { required: true, message: "请输入正确的小程序页面路径", trigger: "blur" }
    ],
    pagePathTwo: [
      {
        required: false,
        message: "请输入正确的小程序页面路径",
        trigger: "blur"
      },
      {
        pattern: /^wx[a-z0-9]{16}$/,
        message: "请输入正确的小程序appid",
        trigger: "blur"
      }
    ],
    coverImg: [
      { required: true, message: "小程序封面不能空！", trigger: "blur" }
    ]
  };
  pushMiniCoverImg() {
    let _this = this;
    if (_this.activeImgValue.length == 0) {
      this.$message.error("请选择封面图片！");
      return;
    }
    _this.toSmallProgramData.coverImg = _this.activeImgValue.MediaUrl;
    _this.toSmallProgramData.WXID = _this.activeImgValue.WXID;
    _this.replyDialogVisible = false;
  }
  modifyminiproject() {
    let _this = this;
    // debugger
    _this.toSmallProgramData =
      _this.momentDataArr[_this.activeRow].rowArr[6].data;
    _this.miniDialogVisible = true;
  }
  pushMiniProject(formName: string) {
    let _this = this;
    (_this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        let imgObj = new Image();
        imgObj.src = _this.toSmallProgramData.coverImg;
        if (imgObj.width != 520 || imgObj.height != 416) {
          this.$message.error("封面图片尺寸不符合要求！！！");
          return false;
        }
        _this.momentDataArr[_this.activeRow].rowArr[6].data =
          _this.toSmallProgramData;
        _this.miniDialogVisible = false;
      } else {
        this.$message.error("请检查表单是否填写正确。");
        return false;
      }
    });
  }

  created() {
    let _this = this;
    // 获取缓存中的当前公众号
    _this.activeTencent = JSON.parse(
      Utils.decrypt(localStorage.getItem("activeTencent") as any, "")
    );
    if (
      _this.momentDataArr[this.activeRow].endRow != 0 &&
      _this.momentDataArr[this.activeRow].endRow != 5
    ) {
      _this.getCateList();
    }
    if (_this.momentDataArr[this.activeRow].endRow == 5) {
      _this.loadCategoryList();
    }
  }
  @Watch("activeRow")
  getVisible(newVal: any, oldVal: any) {
    if (
      this.momentDataArr[newVal].endRow != 0 &&
      this.momentDataArr[newVal].endRow != 6
    ) {
      this.getCateList();
    }
  }
  // 添加素材
  pushFodder() {
    let _this = this;
    let replyType = Number(_this.momentDataArr[_this.activeRow].endRow);
    switch (replyType) {
      case 1:
        _this.pushChooseImg();
        break;
      case 2:
        _this.pushChooseImgTxt();
        break;
      case 3:
        _this.pushChooseVoice();
        break;
      case 4:
        _this.pushChooseVideo();
        break;
      case 5:
        _this.pushChooseTemplate();
        break;
      case 6:
        _this.pushMiniCoverImg();
        break;
    }
  }
  // 清除
  clearSelectedFodder() {
    let _this = this;
    let replyType = Number(_this.momentDataArr[_this.activeRow].endRow);
    if (_this.replyDialogVisible) {
      switch (replyType) {
        case 1:
        case 6:
          _this.activeImgValue = [];
          break;
        case 2:
          _this.activeImgTxtValue = [];
          break;
        case 3:
          _this.activeVoiceValue = [];
          break;
        case 4:
          _this.activeVideoValue = [];
          break;
        case 5:
          _this.activeTempValue = [];
          break;
      }
    } else {
      this.$confirm("确定清除已选素材?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        _this.momentDataArr[this.activeRow].rowArr[replyType].data = "";
        if (replyType == 6) {
          _this.toSmallProgramData = {
            title: "",
            appid: "",
            pagePath: "",
            pagePathTwo: "",
            coverImg: ""
          };
        }
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    }
  }

  // 生命周期
  mounted() {}

  // 文件上传
  UploadImage(param: any) {
    let _this = this;
    if (this.activeCate == "全部") {
      this.$message.error("请选择分组后上传！");
      return;
    }
    let uploadType = "";
    switch (Number(_this.momentDataArr[_this.activeRow].endRow)) {
      case 1:
      case 6:
        uploadType = "AppReplyImage";
        break;
      // case 2:
      //   uploadType = "AppReplyGraphic";
      //   break;
      case 3:
        uploadType = "AppReplyVoice";
        break;
      default:
        this.$message.error("上传类型不能为空, 请联系管理员!");
        return;
        break;
    }

    if(uploadType=="AppReplyImage" && param.file.size>2*1024*1024){
      this.$message.error("图片大小不能超过2M!");
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(param.file);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            { Name: "Type", Value: uploadType },
            { Name: "FileName", Value: param.file.name },
            { Name: "FileBase64", Value: obj },
            { Name: "GroupID", Value: _this.activeCate.ID }, //默认的分级ID
            { Name: "ApplicationID", Value: _this.activeTencent.Aid }
          ]
        };
        _this.uploadLoading = true;
        var res: any = await httpApi.UploadImg(params);
        if (res.ErrorCode == 0) {
          if (!_this.replyDialogVisible) {
            // 将上传的对象赋值到数据数组中；
            _this.momentDataArr[_this.activeRow].rowArr[
              _this.momentDataArr[_this.activeRow].endRow
            ].data = res.output[0].value;
          }
          await _this.getFodderList(_this.activeCate.ID);
          _this.activeCate.TotalNum ++;
          this.$message.success("上传成功！");
        } else {
          (this.$refs['upload_el'] as any).clearFiles();
          this.$message.error("上传失败，请稍后再试！");
          console.log(res.ErrorMessage);
        }
        _this.uploadLoading = false;
      }
    };
  }

  // 上传图片前检测
  beforeAvatarUpload(file: any) {
    let isJPG = false;
    if (
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png" ||
      file.type === "image/gif" ||
      file.type === "image/svg+xml"
    ) {
      isJPG = true;
    } else {
      this.$message.error("上传图片只能是 JPG，png，gif，svg格式!");
    }
    let isLt2M = false;
    if ((isLt2M = file.size / 1024 / 1024 < 2)) {
      isLt2M = true;
    } else {
      this.$message.error("上传图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  // 上传音频前检测
  beforeVoiceUpload(file: any) {
    let isVoice = false;
    if (
      file.type === "audio/mp3" ||
      file.type === "audio/mpeg" ||
      file.type === "audio/x-ms-wma" ||
      file.type === "audio/wav" ||
      file.type === "audio/wav" ||
      file.type === "audio/amr"
    ) {
      isVoice = true;
    } else {
      this.$message.error("上传音频只能是 mp3、wma、wav、amr、m4a格式!");
    }
    let isLT200M = false;
    if ((isLT200M = file.size / 1024 / 1024 < 200)) {
      isLT200M = true;
    } else {
      this.$message.error("上传音频大小不能超过 200M!");
    }
    return isVoice && isLT200M;
  }
  // 文件上传END
}
